import React from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";

export default function ImageShowcase({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const settings = {
    infinite: true,
    speed: 500,
    autoplaySpeed: 6000,
    autoplay: true,
    dots: false,
    draggable: !!isMobile,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: !!isMobile,
    centerPadding: isMobile ? 0 : undefined,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    variableWidth: isMobile ? true : undefined
  };

  return (
    <div id="imageShowcase">
      <div className="header">{content.header}</div>
      {isMobile && content.listImageMobile?.length > 1 ? (
        <Slider {...settings}>
          {content.listImageMobile.map(({ media }, index) => (
            <div key={index} className="imageMobile">
              <img src={media.url} alt="slide" />
            </div>
          ))}
        </Slider>
      ) : isMobile && content.listImageMobile?.length === 1 ? (
        <div className="staticImageMobile">
          <img src={content.listImageMobile[0].media.url} alt="" />
        </div>
      ) : (
        <>{content.imageDesktop.url && <img className="imageDesktop" src={content.imageDesktop.url} alt="" />}</>
      )}
      <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
    </div>
  );
}
